import { Action, Selector, State, StateContext } from '@ngxs/store';
import { RegisterAuthState } from './auth.actions';
import { Injectable } from '@angular/core';

export class AuthStateModel {
  authenticated: boolean;
  status: string;
  inProgress: boolean;
  message: string;
  qrCodeData: string;
}

@State<AuthStateModel>({
  name: 'auth',
})
@Injectable()
export class AuthState {
  constructor() {}

  @Selector()
  static getAuthState(state: AuthStateModel) {
    return state;
  }

  @Action(RegisterAuthState)
  registerAuthState(
    ctx: StateContext<AuthStateModel>,
    action: RegisterAuthState
  ) {
    const { patchState } = ctx;
    const { authenticated, message, inProgress, status, qrCodeData } = action;

    patchState({
      authenticated,
      status,
      inProgress,
      message,
      qrCodeData,
    });
  }
}
